import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { FileBarChart, Scale, ChevronRight, Lock, Wallet } from 'lucide-react';

export default function DashboardInvestisseur({ user, onLogout }) {
  const navigate = useNavigate();

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="space-y-6" data-testid="dashboard-investisseur">
        {/* Header */}
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard Financier</h1>
            <p className="text-gray-600 mt-1 text-sm">
              Bonjour {user?.name || 'Investisseur'}, choisissez un module comptable à consulter.
            </p>
          </div>
          <Badge variant="outline" className="gap-1 border-gray-300 text-gray-600 bg-gray-50">
            <Lock className="h-3 w-3" /> Accès en lecture seule
          </Badge>
        </div>

        {/* 3 cartes de navigation */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card
            onClick={() => navigate('/compte-resultat-investisseur')}
            className="cursor-pointer hover:shadow-xl transition-all border-2 border-indigo-100 hover:border-indigo-500 group"
            data-testid="investisseur-card-cr"
          >
            <CardContent className="p-8 flex flex-col items-start gap-4">
              <div className="p-4 bg-indigo-100 rounded-xl group-hover:bg-indigo-600 group-hover:text-white transition-colors">
                <FileBarChart className="h-8 w-8 text-indigo-600 group-hover:text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Compte de Résultat</h3>
                <p className="text-sm text-gray-600 mt-1">
                  Charges, produits, résultat net et classification PCG. Consultation du compte de résultat en temps réel.
                </p>
              </div>
              <div className="flex items-center gap-1 text-indigo-600 font-semibold text-sm mt-2 group-hover:gap-2 transition-all">
                Ouvrir <ChevronRight className="h-4 w-4" />
              </div>
            </CardContent>
          </Card>

          <Card
            onClick={() => navigate('/bilan-investisseur')}
            className="cursor-pointer hover:shadow-xl transition-all border-2 border-amber-100 hover:border-amber-500 group"
            data-testid="investisseur-card-bilan"
          >
            <CardContent className="p-8 flex flex-col items-start gap-4">
              <div className="p-4 bg-amber-100 rounded-xl group-hover:bg-amber-600 group-hover:text-white transition-colors">
                <Scale className="h-8 w-8 text-amber-600 group-hover:text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Bilan</h3>
                <p className="text-sm text-gray-600 mt-1">
                  Actif et Passif. Immobilisations, stocks, créances, dettes et capitaux propres.
                </p>
              </div>
              <div className="flex items-center gap-1 text-amber-600 font-semibold text-sm mt-2 group-hover:gap-2 transition-all">
                Ouvrir <ChevronRight className="h-4 w-4" />
              </div>
            </CardContent>
          </Card>

          <Card
            onClick={() => navigate('/tresorerie-investisseur')}
            className="cursor-pointer hover:shadow-xl transition-all border-2 border-blue-100 hover:border-blue-500 group"
            data-testid="investisseur-card-tresorerie"
          >
            <CardContent className="p-8 flex flex-col items-start gap-4">
              <div className="p-4 bg-blue-100 rounded-xl group-hover:bg-blue-600 group-hover:text-white transition-colors">
                <Wallet className="h-8 w-8 text-blue-600 group-hover:text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Tableau de Trésorerie</h3>
                <p className="text-sm text-gray-600 mt-1">
                  Encaissements, décaissements, solde de trésorerie et évolution mensuelle cumulée.
                </p>
              </div>
              <div className="flex items-center gap-1 text-blue-600 font-semibold text-sm mt-2 group-hover:gap-2 transition-all">
                Ouvrir <ChevronRight className="h-4 w-4" />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
